export default "__VITE_ASSET__sZ5fg3q8__"